import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BaseService } from '@cl/core/services';
import { ServiceFactory } from '@cl/core/services/service.factory';
import { BaseModel, EntityType } from '@cl/shared/models';
import { NotificationHistory } from '@cl/shared/models/notification-history.model';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalService } from 'ng-zorro-antd/modal';
import { NotificationHistoryModalComponent } from './notification-history-modal/notification-history-modal.component';

@Component({
    selector: 'cl-notification-history-button',
    standalone: false,
    templateUrl: './notification-history-button.component.html',
    styleUrl: './notification-history-button.component.less',
})
export class NotificationHistoryButtonComponent implements OnInit {
    @Input() entityType: EntityType;
    @Input() id: number;

    @Output() loadingChanged: EventEmitter<boolean> = new EventEmitter<boolean>();

    service: BaseService<BaseModel>;

    constructor(
        private serviceFactory: ServiceFactory,
        private messageService: NzMessageService,
        private modalService: NzModalService,
    ) {}

    ngOnInit(): void {
        this.service = this.serviceFactory.getService(this.entityType);
    }

    async openNotificationHistoryModal(): Promise<void> {
        try {
            this.loadingChanged.emit(true);
            const notificationHistory: NotificationHistory[] = (await this.service.getNotificationHistory(this.id)).data;
            this.loadingChanged.emit(false);

            if (!notificationHistory || notificationHistory.length == 0) {
                this.messageService.info('Neviens paziņojums nav nosūtīts');
                return;
            }

            this.modalService.create({
                nzTitle: 'Paziņojumu vēsture',
                nzContent: NotificationHistoryModalComponent,
                nzWidth: 'fit-content',
                nzData: notificationHistory,
            });
        } catch (ex) {
            this.loadingChanged.emit(false);
            console.error(ex);
            if (ex.error?.errors) {
                ex.error.errors.forEach((error) => {
                    this.messageService.error(error);
                });
                return;
            }

            this.messageService.error('Kļūda atlasot paziņojumu vēsturi');
            return;
        }
    }
}
